import React, { useMemo } from 'react';
import { Container, Box, BoxProps } from '@mui/material';
import {
  getModuleSelectedGroup,
  useNavigationGroupPath,
} from '../navigations/navigationPath';
import { getGroupSelectedByQueryParamSelector } from '../../../redux/groups/selectors';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../redux/store.model';
import { PolyglotComponentProps, withPolyglot } from '../../../i18n';
import { useGroupById } from '../../../redux/groups/hooks/useGroupById';
import withHandlingErrors, {
  HandlingErrorWrappedProps,
} from '../../../handlingErrors';
import GroupCard from './Overview/GroupsOverview/GroupCard';
import { RouterComponentProps, withRouter } from '../../../util/route-dom';
import { Outlet } from 'react-router-dom';
import Breadcrumb from '../../../theme/components/Breadcrumb/Breadcrumb';

interface GroupManagerLayoutProps
  extends ConnectedComponentProps,
    PolyglotComponentProps,
    HandlingErrorWrappedProps,
    RouterComponentProps<{ groupId?: string | undefined }> {}

const MainContainer = (props: { moduleSelected: string } & BoxProps) => {
  const { moduleSelected, children, ...others } = props;

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        height: '100%',
        backgroundColor:
          moduleSelected === 'dashboard'
            ? 'background.default'
            : 'background.paper',
      }}
    >
      {children}
    </Container>
  );
};

const ChildContainer = (props: { moduleSelected: string } & BoxProps) => {
  const { moduleSelected, children, ...others } = props;
  if (moduleSelected === 'dashboard') {
    return (
      <Box {...others} px={{ xs: 1, md: 4 }} py={1}>
        {children}
      </Box>
    );
  }
  return (
    <Container
      maxWidth="lg"
      disableGutters
      sx={{ py: 1, px: { xs: 1, md: 0 } }}
    >
      {children}
    </Container>
  );
};
export function GroupManagerLayoutSimple(props: GroupManagerLayoutProps) {
  const { params } = props;
  const { groupId } = params;

  const { data: group, isLoading } = useGroupById(groupId);
  const { pathname } = window.location;

  /* Navigation */
  const moduleSelected = useMemo(() => {
    return getModuleSelectedGroup(pathname);
  }, [pathname]);
  const sectionsNavigation = useNavigationGroupPath();
  return (
    <MainContainer moduleSelected={moduleSelected}>
      {groupId && (
        <GroupCard
          group={group}
          moduleSelected={moduleSelected}
          groupId={groupId}
          loading={isLoading}
        />
      )}
      {sectionsNavigation.length > 1 && (
        <>
          <Box sx={{ mx: { xs: 1, md: 3 } }}>
            <Breadcrumb sections={sectionsNavigation} />
          </Box>
        </>
      )}

      <ChildContainer moduleSelected={moduleSelected}>
        <Outlet />
      </ChildContainer>
    </MainContainer>
  );
}

const mapStateToProps = (
  state: RootState,
  props: RouterComponentProps<{ groupId?: string | undefined }>
) => ({
  group: getGroupSelectedByQueryParamSelector(state, props),
});

const connector = connect(mapStateToProps);
type ConnectedComponentProps = ConnectedProps<typeof connector>;

export default withHandlingErrors(
  withPolyglot(withRouter(connector(GroupManagerLayoutSimple)))
);
